module.exports = __webpack_public_path__ + "static/jianyu2-d3f106ba71706bfff2769b9980740167.jpg";